<template>
    <VoidClaim :Type="AppServiceID"/>
</template>
<script>
import VoidClaim from '@/components/Dental/VoidClaim.vue';
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {

data: function () {
    return {
        AppServiceID : '', 
        }
    },
 components: {
    VoidClaim  : VoidClaim

        },
   created: function() {
    this.$emit('update:layout', LayoutDefault);
     this.AppServiceID = this.$store.getters.GetDentalID;
    },
    beforeCreate: function() {
      
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDentalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDentalID); 
    },
}
</script>
